// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dambjzotoefivvfjynqu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRhbWJqem90b2VmaXZ2Zmp5bnF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5MjUyMzQsImV4cCI6MjA2MTUwMTIzNH0.y3Yem_tXEFcO--jVGtiAOv0jbs3-6DS-CnQG9FLAWMo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);